import MaterialTable, { Column, Action } from "material-table";
import React, { Fragment, useEffect, useState } from "react";

import AtlasPanel from "../../atlas/blades/AtlasPanel";
import AsyncSelect from "react-select/async";
import { reject } from "lodash";
import { DataPortalService, Role } from "../../api/DataPortalService";
import { components } from "react-select";

const ProjectPermissions: React.FC<any> = ({ theme, project, role }) => {
  if (project === null) return <Fragment />;

  const [users, setUsers] = useState<Array<any>>([]);

  useEffect(() => {
    loadUsers();
  }, [project]);
  const loadUsers = async () => {
    const users = await DataPortalService.getUsersByProject(project.id);
    setUsers(users);
  };
  const loadOptions = async (inputValue, callback) => {
    const users = await DataPortalService.getUsersByName(inputValue);
    callback(users.map((v) => ({ label: v, value: v })));
  };

  return (
    <MaterialTable
      title="Users"
      localization={{
        body: {
          emptyDataSourceMessage: <span />,
        },
      }}
      editable={
        role === Role.ADMIN
          ? {
              onRowAdd: (rowdata) => {
                return new Promise(async (resolve, reject) => {
                  await DataPortalService.permissionsGrant(
                    rowdata.username,
                    project.id,
                    rowdata.role.toLowerCase()
                  );
                  await loadUsers();
                  resolve("success");
                });
              },
              onRowUpdate: (rowdata) => {
                return new Promise(async (resolve, reject) => {
                  await DataPortalService.permissionsGrant(
                    rowdata.username,
                    project.id,
                    rowdata.role.toLowerCase()
                  );
                  await loadUsers();
                  resolve("success");
                });
              },
              onRowDelete: (rowdata) => {
                return new Promise(async (resolve, reject) => {
                  await DataPortalService.permissionsRevoke(
                    rowdata.username,
                    project.id,
                    rowdata.role.toLowerCase()
                  );
                  await loadUsers();
                  resolve("success");
                });
              },
            }
          : {}
      }
      options={{
        grouping: false,
        showTitle: true,
        actionsColumnIndex: -1,
        // filtering: true,
        exportButton: false,
        // columnsButton: true,
        search: false,
        exportAllData: true,
        pageSize: 5,
        pageSizeOptions: [],
        maxBodyHeight: "300px",
        headerStyle: {
          fontSize: "12px",
          fontWeight: "bold",
          padding: "3px 10px",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          zIndex: 0,
        },
        rowStyle: {
          fontSize: "13px",
        },
      }}
      columns={[
        {
          title: "Email",
          field: "username",
          editable: "onAdd",
          editComponent: (props) => (
            <div style={{ position: "relative" }}>
              <AsyncSelect
                placeholder="Enter Users's Email"
                cacheOptions
                loadOptions={loadOptions}
                menuPortalTarget={document.querySelector("body")}
                // styles={{
                //   container: (provided, state) => ({
                //     ...provided,
                //     border: "10px solid green",
                //     position: "absolute",
                //     zIndex: 999999,
                //   }),
                //   menu: (provided, state) => ({
                //     ...provided,
                //     backgroundColor: "red",
                //     zIndex: "9999",
                //     position: "absolute",
                //   }),
                // }}
                onChange={(e) => {
                  props.onChange(e.value);
                }}
              />
            </div>
          ),
        },
        {
          title: "Role",
          field: "role",
          initialEditValue: "Collaborator",
          lookup: {
            Admin: "Admin",
            Collaborator: "Collaborator",
            Contributor: "Contributor",
          },
        },
      ]}
      data={users}
    />
  );
};

export default ProjectPermissions;
